export const chargingDefaults = [
  {
    label: 'Je charge à la maison',
    value: 'home',
    defaultPrice: 0.21, // €/kWh, typical home charging rate
  },
  {
    label: 'Je charge sur la route',
    value: 'road',
    defaultPrice: 0.5, // €/kWh, assuming public fast charging
  },
  {
    label: 'Je charge au travail',
    value: 'work',
    defaultPrice: 0.18, // €/kWh, assuming employer-subsidized rates
  },
  {
    label: 'Je charge sur autoroute',
    value: 'highway',
    defaultPrice: 0.7, // €/kWh, premium rapid charging networks
  },
  {
    label: 'Je charge à une borne publique (AC)',
    value: 'public_ac',
    defaultPrice: 0.35, // €/kWh, slower public charging
  },
];
